import Layout from '@/layout'

export default [
	{
		order: 4,
		path: '/elarm-water',
		component: Layout,
		meta: {
			title: '告警配置',
			subtitle: '告警',
			icon: 'icon-gaojing',
			// permissions: ['monitor:water-alarm-config'],
		},
		redirect: '/alarm-water/device',
		children: [
			{
				path: 'equipment',
				name: 'DeviceAlarm',
				meta: {
					title: '设备告警配置',
					keepAlive: true,
					permissions: ['monitor:alarm-config:config:device'],
				},
				component: () => import('@/pages/alarm-water/device-alarm/index.vue'),
			},
			{
				path: 'common',
				name: 'CommonAlarm',
				meta: {
					title: '通用告警配置',
					keepAlive: true,
					permissions: ['monitor:alarm-config:config:system'],
				},
				component: () => import('@/pages/alarm-water/common-alarm/index.vue'),
			},
			{
				path: 'dedicated',
				name: 'DedicatedAlarm',
				meta: {
					title: '专用告警配置',
					keepAlive: true,
					permissions: ['monitor:alarm-config:config:special'],
				},
				component: () => import('@/pages/alarm-water/dedicated-alarm/index.vue'),
			},
		],
	},
]
